// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MUbFFbvJgxMxVhqPFdLv{border:1px solid var(--interaction-neutral-normal);border-radius:12px;padding:16px 16px 16px 14px;display:flex}.MUbFFbvJgxMxVhqPFdLv:hover{border-color:var(--interaction-neutral-hovered)}.K4mzsz0WdfkAi5paUAON{color:var(--content-brand-primary);cursor:pointer}.K4mzsz0WdfkAi5paUAON:hover{color:var(--content-brand-secondary)}.atOcCjOv2jwTxFmru7m0{flex-direction:column;justify-content:space-between;align-items:flex-end;margin-left:auto;display:flex}.Kug6cXV42kYyRvzDB8Ui{flex-direction:column;gap:8px;display:flex}.fbKOnVbBdLsJJGLJ8gem{gap:16px;display:flex}.jCAVo9pu8YBDHWQ_gAjv{margin-right:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoContainer": `MUbFFbvJgxMxVhqPFdLv`,
	"seeDetailsLink": `K4mzsz0WdfkAi5paUAON`,
	"switchContainer": `atOcCjOv2jwTxFmru7m0`,
	"infoContainerData": `Kug6cXV42kYyRvzDB8Ui`,
	"switchContainerButtons": `fbKOnVbBdLsJJGLJ8gem`,
	"iconContainer": `jCAVo9pu8YBDHWQ_gAjv`
};
export default ___CSS_LOADER_EXPORT___;
